import PropTypes from 'prop-types';

const User = ({ firstName, lastName, email }) => {
  return (
    <div className='overflow-hidden'>
      <div className='font-semibold text-[#2E2C34] text-ellipsis overflow-hidden'>
        {firstName} {lastName}
      </div>
      <div className='text-[#84818A] text-[12px] font-medium text-ellipsis overflow-hidden'>{email}</div>
    </div>
  );
};

User.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
};

export default User;
